<template src="./PostQualificationThanks.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import { postQualificationModule } from "@/store/modules/postQualification";
import { PostQualificationGetters } from "@/store/modules/postQualification/getters";
import { Routes } from "@/router/routes";

export default defineComponent({
    computed: {
        ...postQualificationModule.mapGetters({
            token: PostQualificationGetters.Token
        })
    },
    methods: {
        changeData(): void {
            this.$router.push(Routes.PostQualification + this.token);
        }
    }
});
</script>

<style></style>
